import { styled } from '@mui/material'
import { AccessPointActiveIcon } from '@weblite/icons'
import clsx from 'clsx'

const Container = styled('div')(({ theme }) => ({
  width: 26,
  height: 20,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 10,

  gap: 2,
  border: `2px solid ${theme.palette.neutral000}`,
  background: theme.palette.neutral000,

  '&.hasStroke': {
    background: theme.palette.liveGradientH,

    '& > svg': {
      color: theme.palette.neutral000,
    },
  },
}))

export function LiveActiveIcon({
  hasStroke = false,
  className,
}: {
  hasStroke?: boolean
  className?: string
}) {
  return (
    <Container className={clsx(className, { hasStroke })}>
      <AccessPointActiveIcon
        sx={{ color: 'live500', width: '16px', height: '16px' }}
      />
    </Container>
  )
}
